/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { TOTPRegisterChallengeOptions } from './TOTPRegisterChallengeOptions';
import {
    TOTPRegisterChallengeOptionsFromJSON,
    TOTPRegisterChallengeOptionsFromJSONTyped,
    TOTPRegisterChallengeOptionsToJSON,
} from './TOTPRegisterChallengeOptions';

/**
 * 
 * @export
 * @interface TOTPRegisterChallenge
 */
export interface TOTPRegisterChallenge {
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof TOTPRegisterChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof TOTPRegisterChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {TOTPRegisterChallengeOptions}
     * @memberof TOTPRegisterChallenge
     */
    options?: TOTPRegisterChallengeOptions;
}

/**
 * Check if a given object implements the TOTPRegisterChallenge interface.
 */
export function instanceOfTOTPRegisterChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;

    return isInstance;
}

export function TOTPRegisterChallengeFromJSON(json: any): TOTPRegisterChallenge {
    return TOTPRegisterChallengeFromJSONTyped(json, false);
}

export function TOTPRegisterChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': !exists(json, 'options') ? undefined : TOTPRegisterChallengeOptionsFromJSON(json['options']),
    };
}

export function TOTPRegisterChallengeToJSON(value?: TOTPRegisterChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': TOTPRegisterChallengeOptionsToJSON(value.options),
    };
}

